export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8863.070070e1.jpg";